import React from 'react'
import * as Styled from './Showcase.styled'
import logoMeConteUmaFofoca from '../../../../assets/images/home/me_conte_uma_fofoca.jpg'
import logoJogabilidade from '../../../../assets/images/home/jogabilidade.jpg'
import logoUmMilkshakeChamadoWanda from '../../../../assets/images/home/um_milkshake_chamado_wanda.jpg'
import logoCafeComCrime from '../../../../assets/images/home/cafe_com_crime.jpg'
import logoHelenaOPodcastTaPronto from '../../../../assets/images/home/helena_o_podcast_ta_pronto.jpg'
import logoCienciaSuja from '../../../../assets/images/home/ciencia_suja.jpg'
import StyledButton from '../Button/Button'
import { getPodcastPath, getSearchPath } from '../../../../Routes/RouteNames'
import StyledNavLink from '../../../../components/StyledNavLink'

const data = [
  {
    img: logoMeConteUmaFofoca,
    title: 'Me conte uma fofoca',
    podcastId: '64ad6a45fb3e1998a950e4b2',
  },
  {
    img: logoJogabilidade,
    title: 'Jogabilidade',
    podcastId: '5e7f46cae7db3c0ed7cfec62',
  },
  {
    img: logoUmMilkshakeChamadoWanda,
    title: 'Um Milkshake Chamado Wanda',
    podcastId: '5e80499ffe51460ed8e8620c',
  },
  {
    img: logoCafeComCrime,
    title: 'Café Com Crime',
    podcastId: '6061c7e6f37915736cd8d91d',
  },
  {
    img: logoHelenaOPodcastTaPronto,
    title: 'Helena, o podcast tá pronto',
    podcastId: '62eb7aadc71d7e6dabd79e7a',
  },
  {
    img: logoCienciaSuja,
    title: 'Ciência Suja',
    podcastId: '612cdec89093eb6f24e1c4c8',
  },
]

const Showcase: React.FC<{}> = () => {
  return (
    <Styled.SectionWrapper>
      <Styled.SectionShowcase>
        <Styled.TextWrapper>
          <Styled.Title>Descubra</Styled.Title>
          <Styled.Description>
            você não está sozinho nessa. muita gente já está criando, reunindo e
            ganhando.
          </Styled.Description>
        </Styled.TextWrapper>
        <Styled.CardWrapper>
          {data.map((item) => (
            <StyledNavLink to={getPodcastPath(item.podcastId)}>
              <Styled.Card>
                <Styled.CardImg src={item.img} />
                <Styled.CardTitle>{item.title}</Styled.CardTitle>
              </Styled.Card>
            </StyledNavLink>
          ))}
        </Styled.CardWrapper>
        <Styled.ButtonWrapper>
          <StyledNavLink to={getSearchPath()}>
            <StyledButton
              fontSize="small"
              labelColor="black"
              buttonColor="white"
              searchIcon
            >
              E muito mais
            </StyledButton>
          </StyledNavLink>
        </Styled.ButtonWrapper>
      </Styled.SectionShowcase>
    </Styled.SectionWrapper>
  )
}

export default Showcase
